//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { SliceNames } from '@redux/SliceNames';
import { ITikTokLike2BuyModalsState } from '@tiktok/redux/like2buy/modals/tiktokLike2BuyModalsModel';

const initialState: ITikTokLike2BuyModalsState = {
  isDuplicateItemsModalOpen: false,
  duplicateItems: [],
  addedItemsCount: 0,
};

const { actions, reducer } = createSlice({
  name: SliceNames.TikTokLike2BuyModerationModals,
  initialState,
  reducers: {
    openDuplicateItemsModal(
      state,
      action: PayloadAction<{
        alreadyAddedItems: IMlsMediaItem[];
        addedItemsCount: number;
      }>,
    ) {
      state.isDuplicateItemsModalOpen = true;
      state.duplicateItems = action.payload.alreadyAddedItems;
      state.addedItemsCount = action.payload.addedItemsCount;
    },
    closeDuplicateItemsModal(state) {
      state.isDuplicateItemsModalOpen = false;
      state.duplicateItems = initialState.duplicateItems;
    },
  },
});

export const { openDuplicateItemsModal, closeDuplicateItemsModal } = actions;

export { reducer };
